<template>
    <div class="characters-container">
        <div id="bottom-characters" class="d-flex flex-row flex-nowrap align-items-center justify-content-center justify-content-lg-around mt-2">

            <div class="d-flex flex-column pt-lg-3 ml-lg-5" id="teeth_bottom">

                <div class="pl-3">
                    <img src="../../assets/imgs/landing/bottom-caria.png" alt="" class="small ml-sm-5" id="carie_bottom">
                </div>

                <div class="pt-4 pt-md-5">
                    <img src="../../assets/imgs/landing/bottom-lopatari.png" alt="" class="small ml-1">
                </div>

            </div>

            <div>
                <img src="../../assets/imgs/landing/bottom-dintica.png" alt="" class="big" id="dintica_bottom">
            </div>

            <div class="mr-lg-5">
                <img src="../../assets/imgs/landing/bottom-zana.png" alt="" class="big" id="zana_bottom">
            </div>

        </div>

        <div class="footer">
            <img src="../../assets/imgs/general/overlay-shape.png" alt="" class="w-100">
        </div>

    </div>

</template>

<script>
    import anime from 'animejs/lib/anime.js';

    export default {
        name: "BottomCharacters",
        mounted() {

            anime({
                targets: '#carie_bottom',
                direction: 'alternate',
                translateY: [20, -20],
                translateX: 10,
                duration: 4000,
                easing: 'linear',
                loop: true
            });
        }
    }
</script>

<style scoped>

</style>